/**
 * Runtime-input tokens for rule clauses.
 *
 * A clause with `valueKind: RUNTIME_INPUT` stores a token name instead of a
 * literal; the data service binds it to a value from the request's
 * `recipient_metadata` at execution time.
 */

/** Tokens offerable on an attribute even before the query declares them —
 *  without this the first clause to use a token could never be authored. */
const CANDIDATE_TOKENS_BY_ATTRIBUTE: Record<string, readonly string[]> = {
  "gl_transaction.id": ["gl_transaction_ids"],
};

export const candidateTokensForAttribute = (
  attributePath: string | null | undefined,
): string[] => {
  if (!attributePath) return [];
  return [...(CANDIDATE_TOKENS_BY_ATTRIBUTE[attributePath] ?? [])];
};
